export const PAST_EVENTS = [
  {
    id: 'milano2026',
    title: 'Milano, Italy 2026',
    images: [
      'italy2026/20260208_103659.jpg',
      'italy2026/20260208_171354.jpg',
      'italy2026/20260208_181145.jpg',
      'italy2026/20260209_163813.jpg',
      'italy2026/20260209_170338.jpg',
      'italy2026/20260212_000148.jpg',
      'italy2026/20260212_110833.jpg',
      'italy2026/20260213_095018.jpg',
      'italy2026/20260213_211635.jpg',
      'italy2026/FB_IMG_1771131754295.jpg',
      'italy2026/IMG_0528.jpg',
      'italy2026/IMG_0538.jpg',
      'italy2026/IMG_1473.jpg',
      'italy2026/IMG_3409.jpg',
      'italy2026/IMG_3449.jpg',
      'italy2026/IMG_3976.jpg',
      'italy2026/IMG_4448.jpg',
      'italy2026/IMG_4458.jpg',
      'italy2026/IMG_5287.jpg',
      'italy2026/IMG_7140.jpg',
      'italy2026/IMG_7437.jpg',
      'italy2026/IMG_8377.jpg',
      'italy2026/IMG_9717.jpg',
    ]
  },
  {
    id: 'sb2025',
    title: 'Super Bowl 2025 — New Orleans',
    images: [
      'sb2025/IMG_7076.jpg',
      'sb2025/IMG_7087.jpg',
      'sb2025/IMG_8908.jpg',
      'sb2025/HGH_7298.jpg',
      'sb2025/HGH_7317.jpg',
      'sb2025/IMG_4831.jpg',
      'sb2025/IMG_4833.jpg',
      'sb2025/IMG_4835.jpg',
    ]
  },
  {
    id: 'paris2024',
    title: 'Paris Summer Olympics 2024',
    images: [] // Placeholder - photos coming soon
  },
  {
    id: 'sb2024',
    title: 'Super Bowl 2024 — Las Vegas',
    images: [
      'sb2024/HGH_6410.jpg',
      'sb2024/HGH_6432.jpg',
      'sb2024/HGH_6581.jpg',
      'sb2024/HGH_6629.jpg',
      'sb2024/HGH_6649.jpg',
      'sb2024/HGH_6660.jpg',
      'sb2024/HGH_6760.jpg',
      'sb2024/HGH_6768.jpg',
      'sb2024/HGH_6778.jpg',
      'sb2024/HGH_6782.jpg',
      'sb2024/HGH_6807.jpg',
      'sb2024/HGH_6832.jpg',
      'sb2024/HGH_6869.jpg',
    ]
  }
];

export default PAST_EVENTS;
